import React from 'react';

const VideoCard = ({ video, onClick }) => {
  const { poster, title, tag } = video;

  return (
    <div
      onClick={onClick}
      className="group relative rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 ease-in-out hover:scale-105"
    >
      <img
        src={poster}
        alt={title}
        className="w-full h-full object-cover"
      />
      {tag && (
        <div className="absolute bottom-2 left-2 bg-gradient-accent text-white text-xs font-bold px-2 py-1 rounded-md">
          {tag}
        </div>
      )}
      <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity" />
    </div>
  );
};

export default VideoCard;
